<div class="p-4">
    <div class="demo-container">
        <div class="title">HubSpot</div>
        <app-hubspot-sandbox-toggle class="d-block mb-3"></app-hubspot-sandbox-toggle>
        <button
			type="button"
			class="btn btn-primary btn-sm"
			(click)="testHubSpotContacts()"
			*ngIf="!isRunningIftaData" data-testid="api-testing-test-hub-spot-contacts">
			Test HubSpot Contacts
		</button>
		<button
			type="button"
			class="btn btn-primary btn-sm"
			(click)="testHubSpotCompanies(true)"
			*ngIf="!isRunningIftaData" data-testid="api-testing-test-hub-spot-companies">
			Test HubSpot Companies
		</button>
		<button
			type="button"
			class="btn btn-primary btn-sm"
			(click)="testHubSpotCompanies(false)"
			*ngIf="!isRunningIftaData" data-testid="api-testing-sync-hub-spot-companies">
			Sync HubSpot Companies
		</button>
		<button
			type="button"
			class="btn btn-primary btn-sm"
			(click)="syncHubSpotData()"
			*ngIf="!isRunningIftaData" data-testid="api-testing-sync-hub-spot-invoice">
			Sync HubSpot Invoice Data
		</button>
    </div>
    <br/>
    <div class="demo-container">
        <div class="title">SAFER</div>
        <input
			type="text"
			[(ngModel)]="usDotNumber"
			*ngIf="!isRunningIftaData"
			placeholder="USDOT Number" data-testid="api-testing-us-dot-number"/>
		<button
			type="button"
			class="btn btn-primary btn-sm"
			(click)="testSafer()"
			*ngIf="!isRunningIftaData" data-testid="api-testing-test-safer-data">
			Test Safer Data
		</button>
    </div>
    <br/>
    <div class="demo-container">
        <div class="title">Samsara</div>
        <button
			type="button"
			class="btn btn-primary btn-sm"
			(click)="runSamsaraIftaData()"
			*ngIf="!isRunningIftaData" data-testid="api-testing-run-ifta-data">
			Run IFTA Data
		</button>
		<button
			type="button"
			class="btn btn-primary btn-sm"
			(click)="runSamsaraVehicleData()"
			*ngIf="!isRunningIftaData" data-testid="api-testing-run-vehicle-list">
			Run Vehicle List
		</button>
    </div>
    <br/>
    <div class="demo-container">
        <div class="title">Textract</div>
        	<div class="col-md-10" *ngIf="!isRunningIftaData">
			<div
				ng2FileDrop
				*ngIf="!isSavingNewDoc"
				[ngClass]="fileDragged ? 'nv-file-over' : ''"
				[uploader]="documentUploader"
				class="my-drop-zone col-3 m-0 p-0 h-100"
				(dragover)="onDragover()"
				(dragleave)="onDragout()"
				(mouseleave)="onDragout()"
				(drop)="uploadDocumentFile()">
				<label
					for="file-upload"
					role="button" 
					aria-label="Upload"
					class="custom-file-upload py-0 m-0 w-100 h-100 d-flex align-items-center justify-content-center">
					<i class="fa fa-cloud-upload" role="button" aria-label="Upload"></i> Upload
				</label>
				<input
					id="file-upload"
					type="file"
					ng2FileSelect
					[uploader]="documentUploader"
					(change)="uploadDocumentFile()" data-testid="api-testing-upload-file"/>
			</div>
		</div>
        <br/>
    </div>
    <br/>
    <div class="" role="status" *ngIf="isRunningIftaData">
		Running IFTA data
		<i class="fa-solid fa-period"></i>
		<i class="fa-solid fa-period"></i>
		<i class="fa-regular fa-period fa-fade"></i><br />
		<div class="text-danger m-1">
			<i class="fa-duotone fa-fire fa-beat fa-2x"></i><br />
		</div>
		<div class="text-warning m-1">
			<i class="fa-duotone fa-dragon fa-rotate-270 fa-3x"></i>
		</div>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/developer/third-party/api-testing/api-testing.component.html